var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 13.6152C6.5525 13.6152 6.17142 13.4579 5.85675 13.1433C5.54208 12.8286 5.38475 12.4475 5.38475 12C5.38475 11.5525 5.54208 11.1714 5.85675 10.8568C6.17142 10.5421 6.5525 10.3848 7 10.3848C7.4475 10.3848 7.82858 10.5421 8.14325 10.8568C8.45792 11.1714 8.61525 11.5525 8.61525 12C8.61525 12.4475 8.45792 12.8286 8.14325 13.1433C7.82858 13.4579 7.4475 13.6152 7 13.6152ZM7 17.5C5.47433 17.5 4.17625 16.9648 3.10575 15.8942C2.03525 14.8237 1.5 13.5257 1.5 12C1.5 10.4743 2.03525 9.17625 3.10575 8.10575C4.17625 7.03525 5.47433 6.5 7 6.5C8.07183 6.5 9.04108 6.77658 9.90775 7.32975C10.7744 7.88308 11.4359 8.6065 11.8923 9.5H20.8943L23.3943 12L19.548 15.8268L17.6923 14.4328L15.7885 15.846L13.8365 14.5H11.8923C11.4359 15.3872 10.7744 16.1089 9.90775 16.6652C9.04108 17.2218 8.07183 17.5 7 17.5ZM7 16C7.959 16 8.78942 15.7103 9.49125 15.1308C10.1932 14.5513 10.6513 13.841 10.8655 13H14.3077L15.748 13.9963L17.702 12.5673L19.4 13.8655L21.2655 12L20.2655 11H10.8655C10.6513 10.159 10.1932 9.44875 9.49125 8.86925C8.78942 8.28975 7.959 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16Z",
    fill: "#66C15E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpIcon);
export default __webpack_public_path__ + "static/media/cp-icon.b5be46143ae2ad691f43377e8c952de4.svg";
export { ForwardRef as ReactComponent };